import { render, staticRenderFns } from "./PtoManager.vue?vue&type=template&id=2d19447e&scoped=true"
import script from "./PtoManager.vue?vue&type=script&lang=js"
export * from "./PtoManager.vue?vue&type=script&lang=js"
import style0 from "./PtoManager.vue?vue&type=style&index=0&id=2d19447e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d19447e",
  null
  
)

export default component.exports